import { render, staticRenderFns } from "./onebox-sharedwithme.vue?vue&type=template&id=1dc98adf&"
import script from "./onebox-sharedwithme.vue?vue&type=script&lang=js&"
export * from "./onebox-sharedwithme.vue?vue&type=script&lang=js&"
import style0 from "./onebox-sharedwithme.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports